<template>
	<div class="tab-pane fade   show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
		<div class="d-flex bd-highlight  mt-4">
			<div class="p-2 flex-grow-1 bd-highlight">
				<h3>대시보드</h3>
			</div>
			<div class="p-2 bd-highlight">
				<div id="select-store"></div>
			</div>
			<div class="p-2 bd-highlight">
				<div id="select-channel"></div>
			</div>
			<div class="p-2 bd-highlight">
				<input type="text" class="form-control daterange" name="dash-range" value="2023-01-01 ~ 2023-02-01" />
			</div>
		</div>

		<div class="container px-0">
			<div class="row mt-4">
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">광고비</span>

								<img data-bs-title="광고에 사용한 비용" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body  py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ cost }}원</div>
								<div class="p-2 mt-1 rankgap " :class="[adSalesIn ? 'text-danger' : 'text-primary']">{{ costPrev }}원</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">광고매출</span>
								<img data-bs-title="광고로 발생한 매출" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body  py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ adSales }}원</div>
								<div class="p-2 mt-1 rankgap " :class="[adSalesIn ? 'text-danger' : 'text-primary']">{{ adSalesPrev }}원</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">총매출</span>
								<img data-bs-title="모든 상품에 대한 매출" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body  py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ totalSales }}원</div>
								<div class="p-2 mt-1 rankgap " :class="[totalSalesIn ? 'text-danger' : 'text-primary']">{{ totalSalesPrev }}원</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row mt-4">
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">CPC</span>
								<img data-bs-title="클릭당 광고비" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body  py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ cpc }}원</div>
								<div class="p-2 mt-1 rankgap " :class="[cpcIn ? 'text-danger' : 'text-primary']">{{ cpcPrev }}원</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">광고매출비율</span>
								<img data-bs-title="광고매출/총매출" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ adSalesRate }}%</div>
								<div class="p-2 mt-1 rankgap " :class="[adSalesRateIn ? 'text-danger' : 'text-primary']">{{ adSalesRatePrev }}%</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">ROAS</span>
								<img data-bs-title="광고매출/광고비" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body  py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ roas }}%</div>
								<div class="p-2 mt-1 rankgap " :class="[roasIn ? 'text-danger' : 'text-primary']">{{ roasPrev }}%</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col">
					<div class="card">
						<div class="card-header py-1">
							<h4 class="card-title m-0 text-center">
								<span class="p-2 align-middle">T-ROAS</span>
								<img data-bs-title="총매출/광고비" class="exclamationmark pointer" data-bs-toggle="tooltip" data-bs-placement="top" src="/images/exclamationmark.png" />
							</h4>
						</div>
						<div class="card-body  py-1">
							<div class="d-flex justify-content-center">
								<div class="p-2 fs-5">{{ tRoas }}%</div>
								<div class="p-2 mt-1 rankgap " :class="[tRoasIn ? 'text-danger' : 'text-primary']">{{ tRoasPrev }}%</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row mt-4">
				<div class="d-flex flex-row-reverse">
					<div class="btn-group" role="group" aria-label="Basic outlined example">
						<div class="btn-group" role="group" aria-label="Basic radio toggle button group">
							<input type="radio" class="btn-check" name="btnradio" id="day" value="day" autocomplete="off" v-model="dwm" @change="changeDwm" />
							<label class="btn btn-outline-primary dwm" for="day">일</label>

							<input type="radio" class="btn-check" name="btnradio" id="week" value="week" utocomplete="off" v-model="dwm" @change="changeDwm" />
							<label class="btn btn-outline-primary dwm" for="week">주</label>

							<input type="radio" class="btn-check" name="btnradio" id="month" value="month" autocomplete="off" v-model="dwm" @change="changeDwm" />
							<label class="btn btn-outline-primary dwm" for="month">월</label>
						</div>
					</div>
				</div>

				<canvas id="myChart"></canvas>
				<!-- <div id="chart-area"></div> -->
			</div>
		</div>
		<h6 class="text-uppercase mt-5 pb-1">
			대시보드 안내
		</h6>
		<ul>
			<li class="text-muted mb-2">
				광고비는 부가세 포함되어 있습니다.
			</li>
			<li class="text-muted mb-2">
				매출은 결제일 기준입니다.
			</li>
			<li class="text-muted mb-2">
				매출은 배송비 포함되어 있지 않습니다.
			</li>
			<li class="text-muted mb-2">
				교환 및 환불은 포함되어 있지 않습니다.
			</li>
			<li class="text-muted mb-2">
				우측하단 네이버톡톡 또는 채널톡으로 언제든지 상담 가능합니다.
			</li>
		</ul>

		<hr />
		<div class="d-flex flex-row-reverse"></div>
	</div>
</template>

<style scoped>
@import "../../../../css/daterangepicker.css";
@import "../../../../css/toastui-select-box.css";
</style>

<script>
import Swal from "../../../../js/sweetalert2.min.js";
import axios from "axios";
// import Chart from "../../../../js/chart.min.js";
import moment from "moment";
import $ from "jquery";
import "daterangepicker";
import SelectBox from "@toast-ui/select-box";
import "regenerator-runtime/runtime";

export default {
	data() {
		return {
			selectedChannelNo: "",
			startDate: "",
			endDate: "",
			cost: 0,
			costPrev: 0,
			adSales: 0,
			adSalesPrev: 0,
			adSalesIn: true,
			totalSales: 0,
			totalSalesPrev: 0,
			totalSalesIn: true,
			adSalesRate: 0,
			adSalesRatePrev: 0,
			adSalesRateIn: true,
			cpc: 0,
			cpcPrev: 0,
			cpcIn: true,
			roas: 0,
			roasPrev: 0,
			roas: true,
			roasIn: true,
			tRoas: 0,
			tRoasPrev: 0,
			tRoas: true,
			tRoasIn: true,
			dwm: "day",
			totalSalesByDate: "",
			salesByDate: "",
			chart: ""
		};
	},
	beforeMount() {
		this.startDate = moment().subtract(7, "days");
		this.endDate = moment().subtract(1, "days");
		// this.getChannels();
	},
	mounted() {
		this.initDatePickerDashBoard();

		// tooltip 은 다시 만들어야 할수도
		// this.initTooltip();
		// this.initChart();
		// this.getUserAdInfo();
		// this.getChannelProductList();
	},
	methods: {
		invalidSession: function(error) {
			Swal.close();
			if (error && error.response && error.response.status && error.response.status == 401) {
				swal("세션이 만료되었습니다. 다시 로그인 해주세요.").then(() => {
					this.$router.push("/signin");
				});
			} else {
				swal("네트워크에 접속할 수 없습니다.", "네트워크 연결 상태를 확인해주세요.", {
					icon: "info"
				});
			}
		},
		serverError: function() {
			Swal.close();
			swal("잠시 후 다시 시도해주세요.", "지속적으로 발생할 경우 우측하단 채널톡으로 문의주세요.", {
				icon: "info"
			});
		},
		checkError: function(x) {
			if (isNaN(x)) {
				return 0;
			} else if (!isFinite(x)) {
				return 0;
			} else {
				return x;
			}
		},
		numberWithCommas: function(x) {
			let isErrorValue = this.checkError(x);
			if (isErrorValue == 0) {
				return 0;
			} else {
				let round = Math.round(x);
				return round.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
		},
		numberWithColor: function(x) {
			let arrow = "";
			if (x > 0) {
				arrow = "▲";
			} else if (x < 0) {
				arrow = "▼";
			}
			return arrow + x;
		},
		numberWithCommasAndColor: function(x) {
			let arrow = "";
			if (x > 0) {
				arrow = "▲";
			} else if (x < 0) {
				arrow = "▼";
			}
			return arrow + this.numberWithCommas(x);
		},
		initSelectBox: function() {
			let simpleChannels = [];
			for (let channel of this.$parent.channels) {
				if (this.selectedChannelNo == "") {
					this.selectedChannelNo = channel.channelNo;
				}
				let channelInfo = {
					label: channel.channelName,
					value: channel.channelNo
				};
				simpleChannels.push(channelInfo);
			}

			const container = document.getElementById("select-store");
			const selectBox = new SelectBox(container, {
				data: [
					{
						// item group
						label: "스토어",
						data: simpleChannels
					}
				],
				theme: {
					"common.border": "1px solid #e4e4e4",
					"common.color": "#353535",
					"common.background": "white",
					"common.width": "200px",
					"common.height": "40px",
					"common.font-size": "1rem",
					"common.z-index": "20",

					"common.disabled.background": "#f1f1f1",
					"common.disabled.color": "#d8d8d8",

					"dropdown.maxHeight": "300px",

					"itemGroup.items.paddingLeft": "15px",

					"itemGroup.label.color": "black",

					"item.selected.background": "white",
					"item.selected.color": "black",

					"item.highlighted.background": "#355dff",
					"item.highlighted.color": "white"
				}
			});

			let items = document.getElementsByClassName("tui-select-box-item");
			for (var i = 0; i < items.length; i++) {
				var item = items.item(i);
				item.style = "font-size: 1rem;";
			}

			document.getElementsByClassName("tui-select-box-icon")[0].innerText = "";

			selectBox.on(
				"change",
				function(ev) {
					console.log(ev);
					this.selectedChannelNo = ev.curr.value;
					this.updateDashBoard();
				}.bind(this)
			);
			this.updateDashBoard();
		},

		initTooltip: function() {
			const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
			const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
		},
		initDatePickerDashBoard: function() {
			let yesterday = moment()
				.subtract(1, "days")
				.toDate();
			let last7day = moment()
				.subtract(7, "days")
				.toDate();
			let last30day = moment()
				.subtract(30, "days")
				.toDate();
			let last365day = moment()
				.subtract(365, "days")
				.toDate();

			let lastMonthStart = moment()
				.subtract(1, "month")
				.startOf("month")
				.toDate();
			let lastMonthEnd = moment()
				.subtract(1, "month")
				.endOf("month")
				.toDate();
			let lastYearStart = moment()
				.subtract(1, "year")
				.startOf("year")
				.toDate();
			let lastYearEnd = moment()
				.subtract(1, "year")
				.endOf("year")
				.toDate();

			$('input[name="dash-range"]').daterangepicker(
				{
					opens: "left",
					alwaysShowCalendars: true,
					startDate: last7day,
					endDate: yesterday,
					maxDate: yesterday,
					cancelClass: " btn btn-outline-primary ",
					locale: {
						// direction: 'l', //direction of text
						format: "YYYY-MM-DD",
						separator: " ~ ", //separator between the two ranges
						applyLabel: "확인",
						cancelLabel: "취소",
						weekLabel: "주",
						customRangeLabel: "직접입력",
						alwaysShowCalendars: true,

						monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
						daysOfWeek: ["일", "월", "화", "수", "목", "금", "토"],
						firstDay: 0
					},

					ranges: {
						//default value for ranges object (if you set this to false ranges will no be rendered)
						어제: [yesterday, yesterday],
						"최근 7일": [last7day, yesterday],
						"최근 30일": [last30day, yesterday],
						"최근 365일": [last365day, yesterday],
						"지난 1달": [lastMonthStart, lastMonthEnd],
						"지난 1년": [lastYearStart, lastYearEnd]
					}
				},
				function(start, end, label) {
					console.log(start);
					console.log(end);
					console.log(label);
					this.startDate = start;
					this.endDate = end;
					this.updateDashBoard();
				}.bind(this)
			);
		},

		async updateDashBoard() {
			let startDateStr = this.startDate.format("YYYYMMDD");
			let endDateStr = this.endDate.format("YYYYMMDD");

			const params = { channelNo: this.selectedChannelNo, startDate: startDateStr, endDate: endDateStr };
			const response = await axios.get("/ad/getDashBoardInfo", { params });

			if (response.status != 200 || !response.data) {
				swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요. \n 계속 발생하는 경우 우측하단 채널톡 통해\n 문의해주세요.", { icon: "info" });
				return;
			}
			console.log(response.data);

			let totalSales = response.data.totalSales;
			let totalSalesPrev = response.data.totalSalesPrev;
			let totalSalesGap = totalSales - totalSalesPrev;
			this.totalSales = this.numberWithCommas(totalSales);
			this.totalSalesIn = totalSalesGap > 0 ? true : false;
			this.totalSalesPrev = this.numberWithCommasAndColor(totalSalesGap);

			let adSales = response.data.adSales;
			let adSalesPrev = response.data.adSalesPrev;
			let adSalesGap = adSales - adSalesPrev;
			this.adSales = this.numberWithCommas(adSales);
			this.adSalesIn = adSalesGap > 0 ? true : false;
			this.adSalesPrev = this.numberWithCommasAndColor(adSalesGap);

			let cost = response.data.cost * 1.1;
			let costPrev = response.data.costPrev * 1.1;
			let costGap = cost - costPrev;
			this.cost = this.numberWithCommas(cost);
			this.costIn = costGap > 0 ? true : false;
			this.costPrev = this.numberWithCommasAndColor(costGap);

			let click = response.data.click;
			let clickPrev = response.data.clickPrev;
			let clickGap = click - clickPrev;
			this.click = this.numberWithCommas(click);
			this.clickIn = clickGap > 0 ? true : false;
			this.clickPrev = this.numberWithCommasAndColor(clickGap);

			let adSalesRatePrev = this.checkError((adSalesPrev * 100) / totalSalesPrev);
			let adSalesRateGap = this.checkError((adSales * 100) / totalSales - adSalesRatePrev);
			this.adSalesRate = this.checkError((adSales * 100) / totalSales).toFixed(1);
			this.adSalesRateIn = adSalesRateGap > 0 ? true : false;
			this.adSalesRatePrev = this.numberWithColor(adSalesRateGap.toFixed(1));

			let cpcPrev = this.checkError(costPrev / clickPrev);
			let cpcGap = this.checkError(cost / click - cpcPrev);
			this.cpc = this.numberWithCommas(cost / click || 0);
			this.cpcIn = cpcGap > 0 ? true : false;
			this.cpcPrev = this.numberWithCommasAndColor(cpcGap || 0);

			let roasPrev = this.checkError((adSalesPrev * 100) / costPrev);
			let roasGap = this.checkError((adSales * 100) / cost - roasPrev);
			this.roas = this.checkError((adSales * 100) / cost).toFixed(1);
			this.roasIn = roasGap > 0 ? true : false;
			this.roasPrev = this.numberWithColor(roasGap.toFixed(1));

			let tRoasPrev = this.checkError((totalSalesPrev * 100) / costPrev);
			let tRoasGap = this.checkError((totalSales * 100) / cost - tRoasPrev);
			this.tRoas = this.checkError((totalSales * 100) / cost).toFixed(1);
			this.tRoasIn = tRoasGap > 0 ? true : false;
			this.tRoasPrev = this.numberWithColor(tRoasGap.toFixed(1));

			this.totalSalesByDate = response.data.totalSalesByDate;
			this.salesByDate = response.data.salesByDate;
			this.updateChart();
		},
		changeDwm() {
			console.log(this.dwm);
			this.updateChart();
		},
		updateChart: function() {
			console.log("updateChart");
			let totalSalesData = [];
			let adSalesData = [];
			let nonAdSalesData = [];

			let startDateStr = this.startDate.format("YYYY-MM-DD");
			let currDate = moment(startDateStr, "YYYY-MM-DD");

			const labels = [];
			let sumTotalSales = 0;
			let sumAdSales = 0;
			let currDateStr = "";

			switch (this.dwm) {
				case "day":
					while (!currDate.isAfter(this.endDate)) {
						let nonAdSales = 0;
						let ymd = currDate.format("YYYYMMDD");

						let totalSales = this.totalSalesByDate[ymd];
						if (totalSales) {
							totalSalesData.push(totalSales);
							nonAdSales = totalSales;
						} else {
							totalSalesData.push(0);
						}

						let adSales = this.salesByDate[ymd];
						if (adSales) {
							adSalesData.push(adSales);
							nonAdSales -= adSales;
						} else {
							adSalesData.push(0);
						}
						nonAdSalesData.push(nonAdSales);

						currDateStr = currDate.format("MM.DD.");
						labels.push(currDateStr);
						currDate.add(1, "day");
					}
					break;
				case "week":
					if (currDate.day() > 0) {
						currDateStr = currDate.format("MM.DD.");
					}

					while (!currDate.isAfter(this.endDate)) {
						if (currDate.day() == 0) {
							currDateStr = currDate.format("MM.DD.");
						}

						let ymd = currDate.format("YYYYMMDD");

						let totalSales = this.totalSalesByDate[ymd];
						if (totalSales) {
							sumTotalSales += totalSales;
						}

						let adSales = this.salesByDate[ymd];
						if (adSales) {
							sumAdSales += adSales;
						}

						if (currDate.day() == 6 || currDate.isSame(this.endDate, "day")) {
							currDateStr += "~" + currDate.format("MM.DD.");
							labels.push(currDateStr);

							totalSalesData.push(sumTotalSales);
							adSalesData.push(sumAdSales);
							nonAdSalesData.push(sumTotalSales - sumAdSales);
							sumTotalSales = 0;
							sumAdSales = 0;
						}
						currDate.add(1, "day");
					}
					break;
				case "month":
					while (!currDate.isAfter(this.endDate)) {
						let ymd = currDate.format("YYYYMMDD");

						let totalSales = this.totalSalesByDate[ymd];
						if (totalSales) {
							sumTotalSales += totalSales;
						}

						let adSales = this.salesByDate[ymd];
						if (adSales) {
							sumAdSales += adSales;
						}

						if (currDate.daysInMonth() == currDate.date() || currDate.isSame(this.endDate, "day")) {
							let currDateStr = currDate.format("YYYY.MM.");
							labels.push(currDateStr);

							totalSalesData.push(sumTotalSales);
							adSalesData.push(sumAdSales);
							nonAdSalesData.push(sumTotalSales - sumAdSales);
							sumTotalSales = 0;
							sumAdSales = 0;
						}
						currDate.add(1, "day");
					}
					break;
			}

			this.drawChart(labels, totalSalesData, adSalesData, nonAdSalesData);
			//
		},
		drawChart: function(labels, totalSales, adSales, nonAdSales) {
			// let datasets = [
			// 	{
			// 		type: "line",
			// 		label: "총 매출액",
			// 		data: totalSales,
			// 		borderColor: "#40b4b2",
			// 		backgroundColor: "#40b4b2"
			// 	},
			// 	{
			// 		type: "bar",
			// 		label: "광고 매출액",
			// 		data: adSales,
			// 		borderColor: "#FF6384",
			// 		backgroundColor: "#FFB1C1"
			// 	},
			// 	{
			// 		type: "bar",
			// 		label: "비광고 매출액",
			// 		data: nonAdSales,
			// 		borderColor: "#36A2EB",
			// 		backgroundColor: "#9BD0F5"
			// 	}
			// ];
			// let data = {
			// 	labels: labels,
			// 	datasets: datasets
			// };
			// if (this.chart == "") {
			// 	const ctx = document.getElementById("myChart");
			// 	const config = {
			// 		type: "bar",
			// 		data: data,
			// 		options: {
			// 			plugins: {
			// 				title: {
			// 					display: true,
			// 					text: "광고 성과"
			// 				}
			// 			},
			// 			responsive: true,
			// 			scales: {
			// 				x: {
			// 					stacked: true
			// 				},
			// 				y: {
			// 					stacked: true
			// 				}
			// 			}
			// 		}
			// 	};
			// 	this.chart = new Chart(ctx, config);
			// } else {
			// 	this.chart.data = data;
			// 	this.chart.update();
			// }
		},
		spinnerStart: function() {
			let preloader = document.getElementById("preloader");
			preloader.style.visibility = "visible";
			preloader.style.opacity = "0.5";
			preloader.style.background = "#000";
		},
		spinnerEnd: function() {
			let preloader = document.getElementById("preloader");
			preloader.style.visibility = "hidden";
			preloader.style.opacity = "0";
		}
	}
};
</script>
<style>
.pointer {
	cursor: pointer;
}
.exclamationmark {
	width: 16px;
	height: 16px;
}

.btn.btn-outline-primary.dwm {
	padding: 0.375rem 0.75rem;
	color: #fff;
}
.btn-check:active + .btn-outline-primary.dwm,
.btn-check:checked + .btn-outline-primary.dwm,
.btn-outline-primary.dwm.active,
.btn-outline-primary.dwm.dropdown-toggle.show,
.btn-outline-primary.dwm:active {
	color: #fff !important;
	background-color: #0d6efd;
	border-color: #0d6efd;
}
</style>



// WEBPACK FOOTER //
// src/components/main/naverad/DashBoard.vue